import { CrudStoreItemPartner360 } from 'legacy/lut/classes/models/partner360/CrudStoreItemPartner360'
import { IELTData } from 'legacy/lut/classes/models/partner360/ELT/IELTData'
import { ELT_FORM_SECTION } from 'legacy/lut/classes/models/partner360/ELT/IELTFormData'
import { eltEventBus } from 'legacy/lut/components/widgets/public/partner360/ELT/eventBus/eltEventBus'
import { Dispatch, SetStateAction, useEffect } from 'react'

import { CrudStore } from 'core/types/crudStore'

import { fetchGroupMembersString } from '../api/partnerGroup/fetchGroupMembersString'
import { getGroupMainHq } from '../helpers/partnerGroups/getGroupMainHq'
import { TUpdateELTFormData } from '../models/common'
import { IPartnerGroupAdditionalInfo } from '../models/IPartnerGroupAdditionalInfo'
import { fetchMembersCountByPartnerGroup } from '../ui/meetingLogistics/mainInfo/api/fetchMembersCountByPartnerGroup'

interface IProps {
  setWip: Dispatch<SetStateAction<boolean>>
  setPartnerGroupInfo: Dispatch<SetStateAction<IPartnerGroupAdditionalInfo>>
  partnerGroupInfo: IPartnerGroupAdditionalInfo
  updateData: TUpdateELTFormData
}

export const useEventBusSubscribers = ({
  setWip,
  setPartnerGroupInfo,
  partnerGroupInfo,
  updateData,
}: IProps) => {
  useEffect(() => {
    eltEventBus.subscribe('updatePartnerGroupMembers', () => {
      if (partnerGroupInfo.groupId) {
        setWip(true)
        Promise.all([
          fetchMembersCountByPartnerGroup(partnerGroupInfo.groupId, true),
          fetchGroupMembersString(partnerGroupInfo.groupId),
        ])
          .then(([res1, res2]) => {
            setPartnerGroupInfo({ ...partnerGroupInfo, membersCount: res1 })
            updateData('GroupMembers', res2)
          })
          .finally(() => {
            setWip(false)
          })
      }
    })
  }, [partnerGroupInfo, partnerGroupInfo.groupId, setPartnerGroupInfo, setWip, updateData])

  /*
   * TODO
   *  Check why "event bus subscribe" called 2 times. It is the reason why "crud subscribe" was used. "Crud subscribe" works correctly
   * */

  // useEffect(() => {
  //   return () => {
  //     eltEventBus.subscribe('changeGroupMainHqPartner', () => {
  //       setWip(true)
  //       getPartnerGroupData(partnerId, true, false).then((partnerGroupData) => {
  //         setPartnerGroupInfo(partnerGroupData)
  //         forceUpdate(ELT_FORM_SECTION.MEETING_SUMMARY)
  //       })
  //     })
  //   }
  // }, [forceUpdate])

  useEffect(() => {
    return CrudStore.get<IELTData>(
      CrudStoreItemPartner360.JBPEltData,
      'changeGroupMainHqPartner'
    ).subscribe('change', () => {
      if (partnerGroupInfo.groupId) {
        setWip(true)
        getGroupMainHq(partnerGroupInfo.groupId)
          .then((mainHq) => {
            setPartnerGroupInfo({ ...partnerGroupInfo, ...mainHq })
          })
          .finally(() => {
            setWip(false)
          })
      }
    })
  }, [partnerGroupInfo.groupId, setWip, partnerGroupInfo, setPartnerGroupInfo])
}
